import { FC } from 'react'
import { getDateWithoutBloodyTZ } from 'src/utils/date-utils'
import { DatePicker } from 'src/components/date-picker'

type YearPickerProps = {
  label?: string
  date: Date
  onDateChange: (value: Date | null) => void
  minDate?: Date
  maxDate?: Date
  renderLabel?: (date: Date) => string
}
export const YearPicker: FC<YearPickerProps> = ({
  label,
  date,
  onDateChange,
  minDate = getDateWithoutBloodyTZ('2019-01-01'),
  maxDate = new Date(),
  renderLabel,
}) => {
  return (
    <DatePicker
      date={date}
      onDateChange={onDateChange}
      openTo="year"
      views={['year']}
      label={label}
      maxDate={maxDate}
      minDate={minDate}
      renderLabel={renderLabel}
    />
  )
}
